export default "__VITE_ASSET__DcH_Oyi3__"